export const view06ImageOptions = {
  angle: 'view06',
  staticOptions: {
    HullColour: 1,
    Deck: 1,
    BiminiColor: 1,
    BowOption: 1,
    AnchorStern: 1,
    AnchorBow: 1,
    Galley: 1
  },
  mattes: []
}



// WEBPACK FOOTER //
// ./src/Xpower/views/view06.js